import { useContext } from 'react';
import { PageDispatcherContext } from 'providers';

function usePageDispatcher() {
  return useContext(PageDispatcherContext);
}

export { usePageDispatcher };
